import { reduxStore as analytics } from '@app/analytics';
import auth from '@app/redux/auth';
import browse from '@app/redux/browse';
import clientLocale from '@app/redux/clientLocale';
import currency from '@app/redux/currency';
import customer from '@app/redux/customer';
import localization from '@app/redux/localization';
import multiAsk from '@app/redux/multi-ask';
import paymentMethods from '@app/redux/payments';
import portfolioItem from '@app/redux/portfolio-item';
import portfolios from '@app/redux/portfolios';
import productGraph from '@app/redux/product-graph';
import profile from '@app/redux/profile';
import tosPrivacy from '@app/redux/tosPrivacy';
import ui from '@app/redux/ui';

const ducks = [
  auth,
  browse,
  clientLocale,
  currency,
  customer,
  localization,
  multiAsk,
  paymentMethods,
  portfolioItem,
  portfolios,
  productGraph,
  profile,
  tosPrivacy,
  ui,
  analytics,
];

// @ts-expect-error ts-migrate(2339) FIXME: Property 'reducers' does not exist on type '{}'.
const { reducers, sagas } = ducks.reduce(
  (acc, duck) => ({
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'reducers' does not exist on type '{ redu... Remove this comment to see the full error message
    reducers: duck?.reducers
      ? // @ts-expect-error ts-migrate(2339) FIXME: Property 'reducers' does not exist on type '{}'.
        { ...acc.reducers, ...duck.reducers }
      : // @ts-expect-error ts-migrate(2339) FIXME: Property 'reducers' does not exist on type '{}'.
        { ...acc.reducers },
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'sagas' does not exist on type '{ reducer... Remove this comment to see the full error message
    sagas: duck?.sagas ? { ...acc.sagas, ...duck.sagas } : { ...acc.sagas },
  }),
  {},
);

export { reducers, sagas };
